import type { ChangeEvent, ReactNode } from 'react';

import Search from './Search';

type Props = {
  children: ReactNode;
  fitContent?: boolean;
  search?: {
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    value: string;
  };
};

const ROW_DIVIDERS = 'divide-y divide-grey-divide';

export default function DropdownPanel({ children, fitContent, search }: Props) {
  return (
    <div
      className={`flex w-full flex-col overflow-hidden rounded-2xl border border-grey-divide bg-grey-tile ${
        fitContent ? '' : 'max-h-96'
      }`}
    >
      {search ? <Search {...search} /> : null}
      <div
        className={
          fitContent
            ? ROW_DIVIDERS
            : `no-scrollbar overflow-y-auto ${ROW_DIVIDERS}`
        }
      >
        {children}
      </div>
    </div>
  );
}
